import { get } from 'lodash';
import React from 'react';
import styled from '@emotion/styled';
import { withTheme } from '@emotion/react';
import { transparentize } from 'polished';

import { LeaderboardContext } from '../../context';

import {
  Avatar,
  Cell,
  InnerGrid,
  NameCell,
  OuterGrid,
  QuestionCell,
  RankCell,
  ScoreCell,
  ScoreRankText,
  Text,
} from '../../styles';

import Question from './question';
import Stars from '../vector/stars';

const Row = ({ columns, theme, userEntry, questions }) => {
  const avatarSrc = get(userEntry, 'user.links.avatar');

  return (
    <LeaderboardContext.Consumer>
      {({ attributes: leaderboard }) => {
        return (
          <OuterGrid shadow scored={!leaderboard.sorted}>
            <AvatarCell key="avatar">
              <Avatar src={avatarSrc ? avatarSrc : null} />
            </AvatarCell>

            <NameCell key="name">
              <NameText bold>
                {userEntry.user.attributes.first_name}{' '}
                {userEntry.user.attributes.last_name}
              </NameText>
            </NameCell>

            <InnerGrid columns={columns} scored={!leaderboard.sorted}>
              {Object.keys(questions).map(questionKey => (
                <QuestionCell key={questionKey} scored={!leaderboard.sorted}>
                  <Question
                    entry={userEntry.entries[questionKey]}
                    question={questions[questionKey]}
                  />
                </QuestionCell>
              ))}
            </InnerGrid>

            {leaderboard.sorted ? null : (
              <ScoreCell key="score">
                <ScoreRankText highlighted textAlign="right">
                  {userEntry.score}
                </ScoreRankText>

                <Stars height="1.2em" color={theme.highlightColor} />
              </ScoreCell>
            )}

            <RankCell key="rank" sorted={leaderboard.sorted}>
              <ScoreRankText highlighted textAlign="center">
                {userEntry.rank}
              </ScoreRankText>
            </RankCell>
          </OuterGrid>
        );
      }}
    </LeaderboardContext.Consumer>
  );
};

const NameText = styled(Text)`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const AvatarCell = styled(Cell)`
  label: avatar-cell;

  display: grid;
  justify-content: center;

  background: linear-gradient(
    to right,
    ${props => transparentize(1, props.theme.foregroundColor)} 0%,
    50%,
    ${props => props.theme.foregroundColor} 50%
  );
`;

export default withTheme(Row);
